import { sanitizeHtml } from "utils/sanitizeHtml";
import { ComponentProps, forwardRef } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import styled from "styled-components";
import S from "./styled";
import { ISelectProps } from "./type";
import clsx from "clsx";

export const StyledSelect = styled(Select)`
	.Select__control {
		width: 100%;
		align-items: center;
		border: 1px solid #d9d9d9;
		color: #2d3436;
		border-radius: 5px;
		opacity: 1;
		outline: none;
		background: #ffffff;
		font-size: 14px;
		padding: 12px 16px;
		@media only screen and (max-device-width: 600px) {
			font-size: 16px;
		}
		@media (min-width: 1536px) {
			padding: 12px 16px;
			font-size: 18px;
		}
		&::placeholder {
			color: #808080;
			opacity: 1;
		}
		&::-ms-expand {
			display: none;
		}
		&:-ms-input-placeholder {
			color: #808080;
		}

		&::-ms-input-placeholder {
			color: #808080;
		}

		&:disabled {
			cursor: not-allowed;
		}
	}

	.Select__control:hover {
		border-color: #a1a1a1;
	}

	.Select__control--is-focused {
		border-color: #a1a1a1;
		outline: none;
		border: 0px;
	}
	.Select__placeholder {
		vertical-align: middle;
		padding: 0px;
		text-align: center;
		margin: 0px;
		font-size: 14px;
		@media (min-width: 1536px) {
			font-size: 18px;
		}
	}

	.Select__indicator-separator {
		display: none;
	}
	.Select__indicator {
		padding: 0px;
	}
	.Select__dropdown-indicator {
		padding: 0px;
	}

	.Select__value-container {
		.css-1g6gooi {
			padding: 0;
			margin: 0 2px;
		}
		padding: 0px;
		display: flex;
		align-items: center;
		text-align: center;
	}

	.Select__single-value {
		font-size: 14px;
		@media (min-width: 1536px) {
			font-size: 18px;
		}
	}
	.Select__menu {
		margin-top: 1px;
		.Select__menu-list {
			padding: 0;
		}
	}
	.css-b8ldur-Input,
	.css-1bwsx9e-Input {
		padding: 0;
		margin: 0;
	}
	.css-mry1rc {
		margin: 0;
		padding: 0;
	}
`;

type Props = Omit<ComponentProps<any>, ""> & ISelectProps;

const isSelectOptionMatch = (optionValue: unknown, fieldValue: unknown): boolean => {
	if (optionValue === fieldValue) return true;
	if (optionValue == fieldValue) return true;

	const optionNum = Number(optionValue);
	const fieldNum = Number(fieldValue);
	if (
		optionValue !== "" &&
		fieldValue !== "" &&
		fieldValue !== null &&
		fieldValue !== undefined &&
		!Number.isNaN(optionNum) &&
		!Number.isNaN(fieldNum) &&
		optionNum === fieldNum
	) {
		return true;
	}

	return false;
};

const SelectBox = forwardRef<HTMLSelectElement, Props>(
	(
		{
			border,
			color,
			children,
			padding,
			height,
			font,
			onClick,
			onChange,
			radius,
			width,
			className,
			errorMessage,
			text,
			data,
			theme,
			size,
			disabled,
			title,
			titleClassName,
			control,
			register,
			propertiesName,
			autoFocus,
			handleChangeValue,
			clearable,
			...props
		},
		ref,
	) => {
		return (
			<div className="w-full">
				<div>
					{title && (
						<S.Title className={clsx("mb-1 font-bold", titleClassName)}>
							{title}
						</S.Title>
					)}
				</div>
				<div
					style={{
						marginTop: `${title ? 10 : 0}px`,
					}}
				>
					<Controller
						control={control}
						name={propertiesName}
						render={({ field }) => {
							const { onChange: rhfOnChange, onBlur, name, value, ref } = field;
							// react-select expects `null` when empty; `undefined` can leave stale UI after RHF reset().
							const selected =
								value !== undefined && value !== null && value !== ""
									? (data?.find((c: any) =>
											isSelectOptionMatch(c.value, value),
										) ?? null)
									: null;
							return (
								<StyledSelect
									name={name}
									onBlur={onBlur}
									isDisabled={disabled}
									autoFocus={autoFocus}
									menuPlacement="auto"
									value={selected}
									onChange={(val: any) => {
										const next = val?.value ?? "";
										if (handleChangeValue) {
											handleChangeValue(next);
										}
										return rhfOnChange(next);
									}}
									classNamePrefix="Select"
									options={data}
									isOptionDisabled={(option: any) => Boolean(option.isDisabled)}
									inputRef={ref}
									placeholder={`${data?.length > 0 ? data[0]?.label : "Please select"}`}
									{...props}
									isClearable={Boolean(clearable)}
								/>
							);
						}}
					/>
					{errorMessage && (
						<div
							style={{
								color: "#EA3F30",
								font: "normal normal bold 14px/18px Lato",
								marginTop: "5px",
							}}
							dangerouslySetInnerHTML={{ __html: sanitizeHtml(errorMessage) }}
						></div>
					)}
				</div>
			</div>
		);
	},
);
export default SelectBox;
